<template>
  <div class="home">
    <!-- Banner -->
    <p>
      Searching using these keywords:
      <span class="font-weight-bold">{{$route.query.query}}</span>
    </p>

    <!-- Conent section -->
    <ContentSection />
  </div>
</template>

<script>
//import Banner from "../components/search-components/Banner";
import ContentSection from "../components/search-components/ContentSection";
export default {
  name: "Home",
  components: {
    //Banner,
    ContentSection,
  },
};
</script>
